import React, { useState, useRef } from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import icons from "../../../assets/images/constantIcons";
import AddCateenUsersForm from "./AddCanteenUsersForm";
import useAddCateenUsers from "./useAddCateenUsers";

const AddCanteen = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    fetchCateenUsers,
  } = useAddCateenUsers();

  const [isModalOpen, setIsModalOpen] = useState(false);
 
  // Function to toggle the modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  

  return (
    <div className="flex flex-col p-4">
      <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Canteen Users</h1>
      <div className="flex items-center justify-between gap-4 ">
        <button
          className="bg-buttoncolor text-white font-medium text-sm xl:text-base py-2 px-4 rounded-lg w-[150px] text-center"
          onClick={toggleModal}
        >
          Add Users
        </button>
        <AddCateenUsersForm
          isOpen={isModalOpen}
          onClose={toggleModal}
          fetchCateenUsers={fetchCateenUsers}
        />
        <div className="flex gap-3">
          {/* Search Bar */}
          <div className="flex items-center border border-gray-300 bg-white px-3 py-2 rounded-lg w-full max-w-[250px]">
            <icons.GoSearch className="text-gray-500 mr-2" />
            <input
                name="search"
                type="text"
                placeholder="Search"
                className="w-full outline-none bg-transparent text-gray-700 placeholder-gray-400"
                // value={searchQuery}
                // onChange={(e) => setSearchQuery(e.target.value)}
              />
          </div>

          {/* Filter Button */}
          {/* <div className="relative" ref={menuRef}>
            <button
              onClick={openDropdown}
              className="bg-green700 w-10 h-10 flex items-center justify-center rounded-lg"
            >
              <img
                src={images.dashboardsetttingicon}
                alt="Filter"
                className="w-5 h-5"
              />
            </button>

            {dropdownOpen && (
              <div className="absolute top-12 right-0 bg-white shadow-md w-[200px] px-4 py-2 z-40 text-gray-700 rounded-2xl">
                <div className="flex justify-between items-center border-b border-gray-200 py-1 mb-2">
                  <p className="text-base font-medium">Filter</p>
                  <div
                    className="bg-green50 rounded-full p-2 cursor-pointer w-8 h-8 flex items-center justify-center"
                    onClick={openDropdown}
                  >
                    <icons.IoClose className="text-green700" />
                  </div>
                </div>
                <p
                    className={`text-sm text-G500 hover:bg-green50 py-2 rounded-md cursor-pointer ${
                      filterType === "active" ? "" : ""
                    }`}
                    onClick={() => handleFilterChange("active")}
                  >
                    Active
                  </p>
                  <p
                    className={`text-sm text-G500 hover:bg-green50 py-2 rounded-md cursor-pointer ${
                      filterType === "deactive" ? "" : ""
                    }`}
                    onClick={() => handleFilterChange("deactive")}
                  >
                    Deactive
                  </p>
              </div>
            )}
          </div> */}
        </div>
      </div>

      <div className="my-2 mb-6  overflow-auto horizontalscroll">
        <Table columns={columns} data={currentRows} />
      </div>
      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddCanteen;
